'use strict';

var createjs = createjs || {};

createjs.ScaleTransform = class extends createjs.BaseTransform {
	constructor(element) {
		super(element);

		// private variables
		this._tween = null;

		this.el.scaleX = isNaN(this.el.scaleX) ? 1 : this.el.scaleX;
		this.el.fraction.move.rotation = isNaN(this.el.fraction.move.rotation) ? 1 : this.el.fraction.move.rotation;
		this.el.borders.scale = [];
		this.el.fraction.move.scale = 1;
		this.el.fraction.release.scale = 1;

		_.bindAll(this, '_holdBorders', '_stopTween', '_dispatchTweenUpdate', '_dispatchScaleComplete', '_getDistance');
	}

	get SCALE() { return 'scale' };
	get SCALE_COMPLETE() { return 'scaleComplete' };

	_holdBorders(){
		if (! this.el.free.scale) {
			if      (this.el.scaleX < this.el.borders.scale[0]) { this.el.scaleX = this.el.borders.scale[0]; this.el.scaleY = this.el.borders.scale[0]; }
			else if (this.el.scaleX > this.el.borders.scale[1]) { this.el.scaleX = this.el.borders.scale[1]; this.el.scaleY = this.el.borders.scale[1]; }
		}
	};

	_dispatchTweenUpdate(){
		this._holdBorders();

		if (this.lock || this.el.lock) {
			this._stopTween();
		}

		this.el.dispatchEvent(this.SCALE);
	};

	_startTransform(evt){
		if (this.el._activeFingers > 1) {
			this._stopTween();
		}
	};

	_dispatchScaleComplete(){
		this.el.dispatchEvent(this.SCALE_COMPLETE);
	};

	_getDistance(p1, p2) {
		var x = p2.x - p1.x;
		var y = p2.y - p1.y;

		return Math.sqrt((x * x) + (y * y));
	};

	_update(evt){
		if (this.lock || this.el.lock) return;

		if (this.el._activeFingers > 1) {
			this._stopTween();

			var points = [];

			for (var k in this.el._fingers) {
				if (this.el._fingers[k].current) {
					points.push(this.el._fingers[k]);
					if (points.length >= 2) break;
				}
			}

			var scale = this._getDistance(points[0].current, points[1].current) / this._getDistance(points[0].old, points[1].old);

			if(this.debug) console.log('update', this.el.scaleX, this.el.fraction.move.rotation, this.el.fraction.base);

			this.el.scaleX += ((scale - 1) * this.el.fraction.move.rotation * this.el.fraction.base);
			this.el.scaleY = this.el.scaleX;


			this._holdBorders();

			this.el.dispatchEvent(this.SCALE);
		}
	};

	_stopTransform(evt){
		if (this.lock || this.el.lock) return;

		if (this.el._stack.length == 0 || typeof TweenLite === 'undefined' || !this.useTween) {
			this._dispatchScaleComplete();
		} else if (! (typeof TweenLite === 'undefined')) {
			var options = {};
			var average = {scaleX: 0, scaleY: 0};

			for (var i = 1, _len = this.el._stack.length; i < _len; i++) {
				average.scaleX += (this.el._stack[i].scaleX - this.el._stack[i-1].scaleX);
				average.scaleY += (this.el._stack[i].scaleY - this.el._stack[i-1].scaleY);
			}

			average.scaleX = average.scaleX / this.el._stack.length;
			average.scaleY = average.scaleY / this.el._stack.length;

			var fade = 10;

			var speed = 1 * this.el.fraction.release.scale * this.el.fraction.base;

			options.scaleX = this.el.scaleX + average.scaleX * this.el.fraction.release.scale * this.el.fraction.base * fade;
			options.scaleY = this.el.scaleY + average.scaleY * this.el.fraction.release.scale * this.el.fraction.base * fade;

			if (this.el.snap.scale && this.el.snap.scale != 0) {
				options.scaleX = (Math.round(options.scaleX / this.el.snap.scale) * this.el.snap.scale);
				options.scaleY = (Math.round(options.scaleY / this.el.snap.scale) * this.el.snap.scale);
			}

			if (! this.el.free.scale) {
				if      (options.scaleX < this.el.borders.scale[0]) { options.scaleX = this.el.borders.scale[0]; options.scaleY = this.el.borders.scale[0]; }
				else if (options.scaleX > this.el.borders.scale[1]) { options.scaleX = this.el.borders.scale[1]; options.scaleY = this.el.borders.scale[1]; }
			}

			options.ease = Cubic.easeOut;
			options.onComplete = this._dispatchScaleComplete;
			options.onUpdate = this._dispatchTweenUpdate;
			options.overwrite = 'auto';

			this._stopTween();

			this._tween = TweenLite.to(this, speed, options);
		}
	};


}